import React, { useEffect, useState } from "react";
import "../favourites/favourites.css";
import { UserStore } from "../store/store";
import Anchor from "../Link/anchor";
import Global from "../../global";
import {
  favourited,
  getPercentage,
  newFavourites,
  truncate,
} from "../javascript/function";
import SectionHeader from "../sectionHeader/sectionHeader";
import LazyImg from "../lazy/lazy";
import { getSearchPlaylist, getYoutubeSearchPlaylist } from "../api/core";
import CarouselContentLoader from "../loader/contentLoader";
import Message from "../message/message";
import "../landscapeList/landscapeList.css";
import { useTranslation } from "react-i18next";

const Search = (props) => {
  const { t } = useTranslation(["translation"]);
  const currentUser = UserStore.useState((s) => s.user);
  const obj = {
    title: "",
    image: "",
    playlist: [],
  };
  const y_obj = { items: [] };
  const [queryPlayList, setQueryPlayList] = useState(
    Global.VCMS === "YouTube" ? y_obj : obj
  );
  const [loading, isLoading] = useState(false);
  const [error, isError] = useState(false);

  useEffect(() => {
    const playlistDetail = async (id, limit, ylimit) => {
      isLoading(true);
      isError(false);
      /* eslint-disable no-unused-vars */
      if (Global.VCMS === "YouTube") {
        const result = await getYoutubeSearchPlaylist(id, ylimit, limit).then(
          (result) => {
            setQueryPlayList(result.data);
            isLoading(false);
          },
          (error) => {
            isLoading(false);
            isError(true);
          }
        );
      } else {
        const result = await getSearchPlaylist(id, limit).then(
          (result) => {
            setQueryPlayList(result.data);
            isLoading(false);
          },
          (error) => {
            isLoading(false);
            isError(true);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };
    if (props.match.params.searchId) {
      if (Global.VCMS === "YouTube") {
        playlistDetail(Global.JWAPIKEYV2, props.match.params.searchId, 25);
      } else {
        playlistDetail(Global.SPL, props.match.params.searchId, "");
      }
    } else {
      isError(true);
    }
  }, [props.match.params.searchId]);

  if (loading) {
    return <CarouselContentLoader></CarouselContentLoader>;
  } else {
    return (
      <div style={{ paddingTop: "100px", overflow: "hidden" }}>
        <SectionHeader
          title={t("label_Search")}
          linkTitle={""}
          link={""}
          header={
            Global.VCMS === "YouTube"
              ? queryPlayList.items.length !== 0 && !error
                ? true
                : false
              : queryPlayList.playlist.length !== 0 && !error
              ? true
              : false
          }
        ></SectionHeader>
        <div className={Global.THBTD + " landscapeList favourite"}>
          <div className="container-fluid ">
            {Global.VCMS === "YouTube" ? (
              queryPlayList !== null &&
              queryPlayList.items.length !== 0 &&
              !error ? (
                queryPlayList.items.map((item, index) => (
                  <div className="list-item" key={index}>
                    <Anchor
                      className={
                        Global.BORDER
                          ? "slide-one slide-two"
                          : "slide-one slide-two no-border"
                      }
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.id.videoId
                      }
                    >
                      <div
                        className={
                          Global.BORDER
                            ? "slide-image"
                            : "slide-image no-border"
                        }
                      >
                        <LazyImg
                          src={
                            item.snippet.thumbnails
                              ? item.snippet.thumbnails.medium.url
                              : ""
                          }
                          style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                          }}
                          orient={"landscape"}
                        />
                      </div>

                      {Global.THBTD === "BIM" ? (
                        <div className={"ms-exclusive-movie-content onshow"}>
                          <div>
                            <h4>
                              {" "}
                              {item.snippet.title
                                ? truncate(
                                    item.snippet.title,
                                    Global.YOUHEADCHAR
                                  )
                                : ""}{" "}
                            </h4>
                            <p></p>
                          </div>
                        </div>
                      ) : Global.THBTD === "BIMWR" ? (
                        <div className={"ms-exclusive-movie-content onshow"}>
                          <div>
                            <h4>
                              {" "}
                              {truncate(
                                item.snippet.title,
                                Global.YOUHEADCHAR
                              )}{" "}
                            </h4>
                            <p></p>
                          </div>

                          <div className="ms-exclusive-rating">
                            <span className="play_button_icon">
                              {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                              <i className="fa fa-play"></i>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className={"slide-content showed"}>
                          <h2>
                            {truncate(item.snippet.title, Global.HEADCHAR)}
                          </h2>
                        </div>
                      )}
                    </Anchor>
                  </div>
                ))
              ) : (
                <Message
                  message={
                    props.match.params.searchId
                      ? props.match.params.searchId
                      : ""
                  }
                ></Message>
              )
            ) : queryPlayList !== null &&
              queryPlayList.playlist.length !== 0 &&
              !error ? (
              queryPlayList.playlist.map((item, index) => (
                <div className="list-item" key={index}>
                  <Anchor
                    className={
                      Global.BORDER
                        ? "slide-one slide-two"
                        : "slide-one slide-two no-border"
                    }
                    to={
                      "/" +
                      props.match.params.AppId +
                      "/videoPage/" +
                      item.mediaid
                    }
                  >
                    <div
                      className={
                        Global.BORDER ? "slide-image" : "slide-image no-border"
                      }
                    >
                      <LazyImg
                        src={item.image}
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                        }}
                        orient={"landscape"}
                      />
                    </div>
                    <div className={"slide-content showed"}>
                      <h2>
                        {item.title}
                        {Global.FAVOURITES ? (
                          <span
                            className="span"
                            onClick={(event) => {
                              newFavourites(event, item, "page");
                            }}
                          >
                            {" "}
                            <i
                              className={
                                favourited(item.mediaid, currentUser.FAVOURITES)
                                  ? "ri-check-fill"
                                  : "ri-add-line"
                              }
                            ></i>
                          </span>
                        ) : (
                          ""
                        )}
                      </h2>
                    </div>
                    <div className="cwwrapper transparent">
                      <div
                        className="cwprogress"
                        style={{
                          width:
                            getPercentage(
                              item.mediaid,
                              currentUser.WATCHHISTORY
                            ) + "%",
                        }}
                      ></div>
                    </div>
                  </Anchor>
                </div>
              ))
            ) : (
              <Message
                message={
                  props.match.params.searchId ? props.match.params.searchId : ""
                }
              ></Message>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default Search;
